module.exports = __webpack_public_path__ + "img/control.a4399104.svg";